import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { PublicScreen, PrivateScreen } from 'routes/screen-names';
import {
  actionLoaderSelector,
  selectClientPublicInfoSelector,
} from 'redux/selectors';
import { CUSTOMER_DETAIL_REQUEST } from 'redux/actions';
import { isAuthenticated } from 'utils/auth';

export const useAuth = () => {
  const navigate = useNavigate();
  const clientPublicInfo = useSelector(selectClientPublicInfoSelector);
  const customerDetailsLoading = useSelector(
    actionLoaderSelector(CUSTOMER_DETAIL_REQUEST)
  );
  const pathName = window.location.pathname;

  useEffect(() => {
    if (isAuthenticated()) {
      navigate(PrivateScreen.home);
    }
  }, []);

  const handleRequestBtnClick = () => {
    navigate(PublicScreen.register);
  };

  const handleBackToLogInClick = () => {
    navigate(PublicScreen.login);
  };

  const handleForgotUsernameAndPswdClick = () => {
    navigate(PublicScreen.Resetpassword);
  };

  return {
    pathName,
    customerDetailsLoading,
    handleRequestBtnClick,
    handleBackToLogInClick,
    handleForgotUsernameAndPswdClick,
    clientPublicInfo,
  };
};
